<template>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
        <v-container grid-list-xl>
            <v-autocomplete v-model="item.department" :items="departments" item-value="id" item-text="name" :label="$t('Departamento')" />
            <v-layout wrap>
                <v-flex xs12 sm6>
                    <v-text-field :label="$t('Nome')" v-model="item.name" :rules="[rules.required, rules.min(5)]" />
                </v-flex>
                <v-flex xs12 sm6>
                    <v-text-field label="CNPJ" v-model="item.cnpj" inputmode="numeric" :rules="[rules.cnpj, rules.cnpjValidatorDigit]" v-mask="'##.###.###/####-##'" />
                </v-flex>

                <v-flex xs12>
                    <v-text-field :label="$t('Código de referência')" v-model="item.referenceCode" />
                </v-flex>

                <v-flex xs12>
                    <v-switch v-model="item.integrationEnabled" :label="$t('Integração habilitada')" color="primary" />
                </v-flex>

                <v-flex xs12 v-if="item.integrationEnabled && item.id">
                    <v-text-field
                        :label="$t('ID para integração (Chave de cadastro)')"
                        v-model="item.id"
                        readonly
                        :append-icon="'mdi-content-copy'"
                        @click:append="copyToClipboard(item.id)"
                        hint="Use este ID como identificador no software de fábrica"
                        persistent-hint
                    />
                </v-flex>

                <v-flex xs12>
                    <v-btn :loading="lock" :disabled="!valid" color="success" @click="validate">{{ $t("Salvar") }}</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

export default {
    directives: { mask },

    props: {
        itemToEdit: {
            type: Object,
        },
        lock: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            rules,
            valid: true,
            itemClean: {
                name: "",
                cnpj: "",
                department: null,
                referenceCode: "",
                enable: true,
                integrationEnabled: false,
            },
            item: { ...this.itemClean },
            departments: null,
            // storeTypes,
            brands: null
        };
    },

    watch: {
        itemToEdit: {
            immediate: true,
            handler(newVal) {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                }

                this.$nextTick(() => {
                    if (newVal == null) {
                        this.item = { ...this.itemClean };
                    } else {
                        this.item = { ...newVal };
                    }
                });
            },
        },
    },

    methods: {
        getDepartments() {
            this.$http
                .get(`departments`)
                .then((result) => {
                    if (result) {
                        this.departments = result;
                    }
                })
                .catch(() => {
                    this.departments = null;
                });
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("save", this.item);
            }
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$eventHub.$emit("msgSuccess", this.$t("Chave copiada com sucesso!"));
            }).catch(() => {
                this.$eventHub.$emit("msgError", this.$t("Erro ao copiar a chave"));
            });
        },
    },

    mounted() {
        this.getDepartments();
        if (this.$refs.form) {
            this.$refs.form.reset();
        }
    },
};
</script>